module.exports = __webpack_public_path__ + "static/media/driver-icon.6f6896eb.png";